import React, { useState } from 'react';
import Redux from 'spwa-ui-library/esm/redux';
import { selectCountryValidations } from 'spwa-ui-library/esm/redux/store/configSlice.js';
import { selectCurrentCountry } from 'spwa-ui-library/esm/redux/store/profileSlice.js';
import { Grid, Typography } from '@material-ui/core';
import css from './index.module.scss';

const { useSelector } = Redux;

const OrderSummaryThankYou = ({ orderInfo, isDesktop }) => {
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  const vatPercentage = countryValidations?.constants?.cartAmount?.find(
    (each) => each.name === 'TAX'
  );
  return (
    <Grid className={css.root}>
      <Grid className={css.container}>
        <Grid className={css.accordionData}>
          <Grid className={css.accordionDataProps}>
            <Typography className={css.warningTypo}>
              {vatPercentage?.value} {orderInfo.vat.amount} {countryValidations?.currency}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrderSummaryThankYou;
